import React, { useState } from "react";

import "./loginregister.css";

import axios from "axios";
import jwt_decode from "jwt-decode";

import Loginsession from "../loginsession/Loginsession";
import Signup from "../signup/Signup";
import Passreset from "../passreset/Passreset";

export default function Loginregister() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addclass, setaddclass] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginstatus, setloginmessage] = useState("");

  const verifyLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios
        .post("https://services.lafemasystems.co.ke/api/login", {
          email,
          password,
        })
        .then((response) => {
          setLoading(false);
          if (response.data.success === 0) {
            setloginmessage(response.data.data);
          } else {
            setUser(response.data);
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const refreshToken = async () => {
    try {
      const res = await axios.post("http://localhost:5000/api/refresh", {
        token: user.refreshToken,
      });
      setUser({
        ...user,
        accessToken: res.data.accessToken,
        refreshToken: res.data.refreshToken,
      });
      return res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const axiosJWT = axios.create();
  //regeneratees refresh token automaticaly
  axiosJWT.interceptors.request.use(
    async (config) => {
      let currentDate = new Date();
      const decodedToken = jwt_decode(user.accessToken);
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        const data = await refreshToken();
        config.headers["authorization"] = "Bearer " + data.accessToken;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return (
    <div className="prophet">
      {!user ? (
        <div className="login">
          {!loading ? (
            <div className="sublogin">
              <div className="leftlogin">
                <div className={`landlord ${addclass}`}>
                  <div className="tenant loginn">
                    <form className="loginregister">
                      <h1>Login</h1>
                      <input
                        type="email"
                        placeholder="EMAIL"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <input
                        type="password"
                        placeholder="PASSWORD"
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />

                      <b>{loginstatus}</b>

                      <button
                        type="submit"
                        className="butto"
                        onClick={verifyLogin}
                      >
                        LOGIN
                      </button>
                    </form>
                  </div>
                  <div className="tenant signupp">
                    <Signup />
                  </div>
                  <div className="tenant passwordd">
                    <Passreset />
                  </div>
                </div>
              </div>
              <div className="rightlogin">
                <button
                  className="threebuts"
                  onClick={() => setaddclass("login-active")}
                >
                  Login
                </button>

                <button
                  className="threebuts"
                  onClick={() => setaddclass("register-active")}
                >
                  Register
                </button>

                <button
                  className="threebuts"
                  onClick={() => setaddclass("reset-active")}
                >
                  Forgot Password
                </button>
              </div>
            </div>
          ) : (
            <div class="circular">
              <div class="inner"></div>
              <div class="number">Plese wait...</div>
              <div class="circle">
                <div class="bar left">
                  <div class="progress"></div>
                </div>
                <div class="bar right">
                  <div class="progress"></div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <Loginsession logedinuser={user} />
      )}
    </div>
  );
}
